import Bouncer from 'formbouncerjs';
import axios from 'axios';

const baseBouncerConfig = {
  fieldClass: 'form-field--error',
  errorClass: 'form-group__message',

  customValidations: {
    honeyPot: field => !!(field.name.toLowerCase() === 'a_password' && field.value.length > 0),
    select: (field) => {
      if (field.tagName !== 'SELECT') {
        return false;
      }

      const optionsArray = [];

      for (let i = 0; i < field.length; i++) {
        optionsArray.push(field[i]);
      }

      return optionsArray.filter(o => o.disabled)[0].selected;
    },
  },

  messages: {
    missingValue: {
      default: field => field.getAttribute('data-error-message')
          ? field.getAttribute('data-error-message')
          : 'Required',
      checkbox: field => field.getAttribute('data-error-message')
          ? field.getAttribute('data-error-message')
          : 'Required',
      radio: field => field.getAttribute('data-error-message')
          ? field.getAttribute('data-error-message')
          : 'Required',
    },
    patternMismatch: {
      email: field => field.getAttribute('data-mismatch-message')
          ? field.getAttribute('data-mismatch-message')
          : 'Please enter a valid email address.',
    },
  },
};

function tryShowThankYouMessage(form) {
  const thankYouSelector = form.getAttribute('data-thank-you-selector');
  if (!thankYouSelector) return false;
  // look for selector in the parent of the form, then if not found in entire document
  let thankYouElement = form.parentElement.querySelector(thankYouSelector);
  if (!thankYouElement) thankYouElement = document.querySelector(thankYouSelector);
  if (!thankYouElement) return false;

  thankYouElement.style.display = 'block';
  form.style.display = 'none';
  return true;
}

function setFormErrorMessage(form, message) {
  const errorMessageElement = form.getElementsByClassName(
    'form__error-message',
  )[0];
  if (errorMessageElement) {
    errorMessageElement.innerHTML = message
      .replace(/</, '&lt;')
      .replace(/>/g, '&gt;');
    errorMessageElement.style.display = 'block';
  }
}

function ajaxFormSubmitted(form) {
  if (form.classList.contains('form--ajax-pending')) {
    return;
  }
  form.classList.add('form--ajax-pending');

  let aPasswordValue = null;
  let tStampValue = null;
  const formItems = [];

  const inputs = Array.from(form.querySelectorAll('input, textarea, select'));

  inputs.forEach((el, index) => {
    if (el.name) {
      if (el.tagName.toLowerCase() === 'select') {
        formItems.push({
          name: el.name,
          value: el.options[el.selectedIndex].value,
          index: formItems.length,
        });
      } else if (el.name.toLowerCase() === 'a_password') {
        aPasswordValue = el.value;
      } else if (el.name.toLowerCase() === 't_stamp') {
        tStampValue = el.value;
      } else {
        formItems.push({
          name: el.name,
          value: el.value || '',
          index,
        });
      }
    }
  });

  const submitErrorMessage =    form.getAttribute('data-ajax-submit-error-message')
    || 'An error has occurred, please check your connection or try again.';
  const postDataJson = form.getAttribute('data-ajax-base-data') || '{}';

  let postData = {};
  try {
    postData = JSON.parse(postDataJson);
  } catch (e) {
    // pass
  }

  Object.assign(postData, {
    Items: formItems,
    A_Password: aPasswordValue,
    T_Stamp: tStampValue,
  });
  
  axios
    .post(form.action, postData)
    .then((response) => {
      if (!response.data) {
        throw new Error('Invalid response');
      }
      if (response.data.success) {
        if (!tryShowThankYouMessage(form)) {
          window.location = response.data.redirectUrl;
        }
      } else {
        setFormErrorMessage(
          form,
          response.data.message || 'An error occurred, please try again later.',
        );
      }
    })
    .catch((error) => {
      setFormErrorMessage(form, submitErrorMessage);
      window.console.error('Error while submitting form:', error);
    })
    .finally(() => {
      form.classList.remove('form--ajax-pending');
    });
}

document.addEventListener('DOMContentLoaded', () => {
  const contactForms = document.querySelectorAll('.contact-form-embed-wrapper');
  contactForms.forEach(formWrapper => {
    const tStampInput = formWrapper.querySelector('#TStamp');
    if (tStampInput) {
      const unixTimestamp = Math.floor(Date.now() / 1000);
      tStampInput.value = unixTimestamp;
    }
  });
  const selectors = {
    nonAjax: '.form:not(.form--ajax-submit)',
    validatedAjax: '.form--validate.form--ajax-submit',
    nonValidatedAjax: '.form--ajax-submit:not(.form--validate)',
    validatedNonAjax: '.form--validate:not(.form--ajax-submit)',
  };
  const validatedForms = document.getElementsByClassName('form--validate');
  const nonValidatedAjaxForms = Array.from(
    document.querySelectorAll(selectors.nonValidatedAjax),
  );

  if (validatedForms && validatedForms.length > 0) {
    // non-ajax form validation
    Bouncer(selectors.validatedNonAjax, baseBouncerConfig);

    // for non ajax forms which open in new frame, try showing
    // the thank you message (ajax forms handled in ajaxFormSubmitted)
    Array.from(document.querySelectorAll(selectors.nonAjax)).forEach((form) => {
      form.addEventListener('submit', () => {
        // timeout to ensure the message doesn't show before new tab starts loading
        // and the browser switches to it
        setTimeout(() => {
          tryShowThankYouMessage(form);
        }, 200);
      });
    });

    // ajax form validation
    Bouncer(
      selectors.validatedAjax,
      Object.assign(
        {
          disableSubmit: true,
          emitEvents: true,
        },
        baseBouncerConfig,
      ),
    );

    // handle validated ajax form submission
    document.addEventListener(
      'bouncerFormValid',
      (event) => {
        const form = event.target;
        if (form.classList.contains('form--ajax-submit')) {
          ajaxFormSubmitted(form);
        }
      },
      false,
    );
  }

  // handle non-validated ajax form submission
  nonValidatedAjaxForms.forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      ajaxFormSubmitted(form);
      return false;
    });
  });

  const selects = document.querySelectorAll('select');
  selects.forEach((select) => {
    select.addEventListener(
      'change',
      (event) => {
        const selectedOption = event.target[event.target.options.selectedIndex];
        if (!selectedOption.disabled) {
          select.classList.add('select--selected');
        }
      },
      false,
    );
  });
});

function hideHoneypotFields() {
  const honeypotFields = document.querySelectorAll('[name="a_password"]');
  Array.from(honeypotFields).forEach((field) => {
    // eslint-disable-next-line no-param-reassign
    field.style.display = 'none';
  });
}

document.addEventListener('bouncerInitialized', hideHoneypotFields, false);
